import { appVariant } from '@util/AppUtils';
// TODO: performance can probably be improved by embedding directly as data:image/svg+xml
// note IE compatibility: https://css-tricks.com/probably-dont-base64-svg/#update-on-ie
// https://www.npmjs.com/package/mini-svg-data-uri looks good
export const lock = '/images/icons/lock.svg';
export const lockUnlocked = '/images/icons/lockUnlocked.svg';
export const lockBlueUnlocked = '/images/icons/lockBlueUnlocked.svg';

const lockPeachUnlocked = '/images/icons/lockPeachUnlocked.svg';
const lockBrownUnlocked = '/images/icons/lockBrownUnlocked.svg';
export const tickOutline = '/images/icons/tickOutline.svg';
const tickGreen = '/images/icons/tickGreen.svg';
export const tickWhite = '/images/icons/tickWhite.svg';
const tickBrown = '/images/icons/tickBrown.svg';
const tickBlue = '/images/icons/tickBlue.svg';
const tick5f5f5f = '/images/icons/tick5f5f5f.svg';
export const volume = '/images/icons/volume.svg';
export const volumeBlue = '/images/icons/volumeBlue.svg';
export const books = '/images/icons/books.svg';
export const booksBlue = '/images/icons/booksBlue.svg';
export const air = '/images/icons/air.svg';
export const graph = '/images/icons/graph.svg';
export const graphBlue = '/images/icons/graphBlue.svg';
export const wheel = '/images/icons/wheel.svg';
export const wheelBlue = '/images/icons/wheelBlue.svg';
export const refresh = '/images/icons/refresh.svg';
export const refreshBlue = '/images/icons/refreshBlue.svg';
export const sleepBlue = '/images/icons/sleepBlue.svg';
export const plus = '/images/icons/plus.svg';
export const plusGreen = '/images/icons/plusGreen.svg';
export const plusBlue = '/images/icons/plusBlue.svg';
export const volumeTurquoise = '/images/icons/volumeTurquoise.png';
export const stressTurquoise = '/images/icons/stressTurquoise.png';
export const hcpTurquoise = '/images/icons/hcpTurquoise.png';
export const booksTurquoise = '/images/icons/booksTurquoise.png';
export const heartTurquoise = '/images/icons/heartTurquoise.png';
export const wheelTurquoise = '/images/icons/wheelTurquoise.png';
export const airTurquoise = '/images/icons/airTurquoise.png';
export const crossTurquoise = '/images/icons/crossTurquoise.png';
export const backBlack = '/images/icons/backBlack.svg';
export const chevronLeft = '/images/icons/chevronLeft.svg';
export const lightbulb = '/images/icons/lightbulb.svg';
export const reviewsBlock = '/images/icons/reviewsBlock.svg';
export const greenTick = '/images/icons/greenTick.svg';
export const copyWhite = '/images/icons/copyWhite.svg';
export const certificate = '/images/icons/certificate.png';
export const audio = '/images/icons/audio.png';
export const lightning = '/images/icons/lightning.png';
export const book = '/images/icons/book.png';
export const support = '/images/icons/support.png';
export const medal = '/images/icons/medal.svg';
export const document = '/images/icons/document.svg';
export const filters = '/images/icons/filters.svg';
export const heartbeat = '/images/icons/heartbeat.svg';
export const shakingHands = '/images/icons/shakingHands.svg';
export const target = '/images/icons/target.svg';
export const sparkles = '/images/icons/sparkles.svg';
export const starIcon = '/images/icons/starIcon.png';
export const volumeHigh = '/images/icons/volumeHigh.svg';
export const bookOpen = '/images/icons/bookOpen.svg';
export const wind = '/images/icons/wind.svg';
export const crosshairs = '/images/icons/crosshairs.svg';
export const shieldWhite = '/images/icons/shieldWhite.svg';
export const unlockWhite = '/images/icons/unlockWhite.svg';
export const bellWhite = '/images/icons/bellWhite.svg';
export const starOutlineWhite = '/images/icons/starOutlineWhite.svg';
export const clockGreen = '/images/icons/clockGreen.svg';
export const tagGreen = '/images/icons/tagGreen.svg';

export const AppIcons = {
  tickIcon: appVariant({
    nerva: tickWhite,
    meno: tickBrown,
    quit: tickWhite,
    pain: tick5f5f5f,
  }),
  unlocked: appVariant({
    nerva: lockPeachUnlocked,
    meno: lockBrownUnlocked,
    quit: lockPeachUnlocked,
    pain: lockBlueUnlocked,
  }),
  tickListIcon: appVariant({
    nerva: tickGreen,
    meno: tickBlue,
    quit: tickGreen,
    pain: tick5f5f5f,
  }),
};
